import {
  Button,
  Col,
  Form,
  Row,
  Select,
  Input,
  Icon,
} from "antd";
import { debounce } from "lodash";
import React, { Component } from "react";
import ModalFilters from "./modalFilter";

class OfferSearchField extends Component {
  state = {
    filterModalVisible: false,
    search: "",
    resetFilter: false,
  };

  triggerFilterModal = () => {
    this.setState({
      filterModalVisible: true,
    });
  };

  triggenWhenClose = () => {
    this.setState({
      filterModalVisible: false,
    });
  };

  handleOnResetFilter = () => {
    const { cb } = this.props;
    this.setState({
      resetFilter: true,
    });
    cb("");
  };

  handleSubmittedForm = (payload) => {
    const { cb } = this.props;

    if (this.state.search.length > 0) {
      payload["search"] = this.state.search;
    }

    const parsedJson = JSON.stringify(payload);
    cb(parsedJson);
  };

  handleOnChangeSearch = (event) => {
    event.persist();

    if (!this.debouncedFn) {
      this.debouncedFn = debounce(() => {
        const { cb } = this.props;
        const text = String(event.target.value).replace(/\s/g,"")
        const payload = {
          search: text,
        };

        this.setState({
          search: text,
        });

        const parsedJson = JSON.stringify(payload);
        cb(parsedJson);
      }, 600);
    }

    this.debouncedFn();
  };

  render() {
    let { onCreate, revisionList, countryList } = this.props;

    return (
      <div>
        <Row type="flex" style={{ margin: "24px" }}>
          <Col span={5}>
            <Input
              prefix={<Icon type="search" />}
              placeholder="Search Offer"
              onChange={this.handleOnChangeSearch}
            />
          </Col>
          <Col span={10}>
            <span style={{ fontWeight: "bold", margin: "0 8px" }}>
              Custom Filter
            </span>
            <Button onClick={() => this.triggerFilterModal()}>
              Custom Filter <Icon type="setting" />
            </Button>
            <span
              style={{
                fontSize: "12px",
                margin: "0 8px",
                textDecoration: "underline",
              }}
              className="touchable"
              onClick={() => this.handleOnResetFilter()}
            >
              Reset Filter
            </span>
          </Col>
          <Col style={{ textAlign: "end" }} push={2}>
            <span style={{ fontWeight: "bold", margin: "0 8px" }}>Sort By</span>
            <Select defaultValue={"default"} style={{ width: "90px" }}>
              <Select.Option key={1} value={"default"}>
                Default
              </Select.Option>
            </Select>
            <Button
              type="primary"
              style={{ margin: "0 6px" }}
              onClick={onCreate}
            >
              <Icon type="plus" />
              Add Offer
            </Button>
          </Col>
        </Row>
        <ModalFilters
          visible={this.state.filterModalVisible}
          revisionList={revisionList}
          onClose={this.triggenWhenClose}
          countryList={countryList}
          submit={this.handleSubmittedForm}
          reset={this.state.resetFilter}
          cbReset={() =>
            this.setState({
              resetFilter: false,
            })
          }
        />
      </div>
    );
  }
}

export default Form.create({ name: "offer-management-filters" })(
  OfferSearchField
);



// WEBPACK FOOTER //
// ./src/containers/OfferManagement/form.js